import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled, { css } from 'styled-components';
import { setRepeat } from '../../../store/TrackSlice';
import { Button } from '../../_atoms/Button';
import { AudioPlayerTime } from '../../_molecules/AudioPlayerTime';
import { AudioProgressBar } from '../../_molecules/AudioProgressBar';

const ProgressBarWrap = styled.div`
  background: center /contain no-repeat;
  align-self: flex-end;
  justify-self: center;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  width: 931px;
  height: 98px;
  background-image: url(https://content.chungchy.com/PhonicsHero/web_resource/images/audioPlayer/audio_progress_bg.png);

  ${(props) => props.page && css`
    width: 1330px;
    height: 140px;
  `}
`;

export const AudioProgressWrap = (props) => {
  const state = useSelector((state) => state);
  const dispatch = useDispatch();

  return (
    <ProgressBarWrap type={props.type} page={props.page}>
      <Button type="repeat" onClick={() => dispatch(setRepeat(!state.track.repeat))} className={state.track.repeat && 'act'} page={props.page}/>
      <AudioProgressBar page={props.page}/>
      <AudioPlayerTime page={props.page}/>
    </ProgressBarWrap>
  );
};